import {
  GoabDivider,
  GoabIcon,
  GoabSpacer,
  GoabText,
} from '@abgov/angular-components';
import { Component } from '@angular/core';

@Component({
  selector: 'app-help-and-support',
  imports: [GoabText, GoabDivider, GoabIcon, GoabSpacer],
  templateUrl: './help-and-support.html',
  styleUrl: './help-and-support.scss',
})
export class HelpAndSupport {
  readonly supportRequestHref =
    'https://forms.office.com/pages/responsepage.aspx?id=Bhy1K5uvxUKL9Tw7exCFC8_JYMzFJDVHkjRaje7NDgRUOU5aMjBCVE1aMDBJSFdGNTJUU0xQS1JYUy4u&route=shorturl';
}
